var _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIllustrationError = function SvgIllustrationError(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 360",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 245.4,
    cy: 253.1,
    r: 55.6,
    fill: "var(--color-alert-lighten)",
    transform: "rotate(-90 245.4 253)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 106.6,
    r: 55.6,
    fill: "var(--color-alert-lighten)",
    transform: "rotate(-90 114 106.6)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-alert-lighten)",
    d: "m267.913 122.889 4.463-37.435 37.435 4.464-4.464 37.435zM50 276.4l8.288-36.778 36.778 8.289-8.288 36.777z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-alert)",
    d: "M183 95.6c-48.7 0-88.4 39-88.4 86.8A87.7 87.7 0 0 0 183 269c48.7 0 88.4-39 88.4-86.7A87.7 87.7 0 0 0 183 95.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-white)",
    d: "M183 186.2c1.1 0 2-.4 2.8-1 .7-.8 1.1-1.7 1.1-2.8v-15.6c0-1-.4-2-1.1-2.7s-1.7-1-2.8-1c-1 0-2 .3-2.7 1-.7.8-1.1 1.7-1.1 2.8v15.6c0 1 .4 2 1.1 2.7s1.7 1 2.7 1m0 15.5c1.1 0 2-.4 2.8-1.2.7-.7 1.1-1.6 1.1-2.7s-.4-2-1.1-2.8a3.7 3.7 0 0 0-2.8-1c-1 0-2 .3-2.7 1-.7.8-1.1 1.7-1.1 2.8 0 1 .4 2 1.1 2.7.7.8 1.7 1.2 2.7 1.2m0 19.3a37.5 37.5 0 0 1-27.3-11.3 39 39 0 0 1-8.2-42.4 39 39 0 0 1 35.5-23.5 37.6 37.6 0 0 1 27.3 11.3 39 39 0 0 1 8.3 42.3A39 39 0 0 1 183 221"
  })));
};
export default SvgIllustrationError;